(function() {
    'use strict';

    angular
        .module('app.service')
        .factory('trainingInnerService', trainingInnerService);


    function trainingInnerService(headerService,sysCode, enumService, $http, apiUrl, isTestMode, testData, $q, $rootScope, ctmsService, commonService, translateService) {
        var enumCourseType = enumService.courseType;
        var service = {
            getCourseLog: getCourseLog,
            getFinancial: getFinancial,
            getBankBook: getBankBook,
            getExterior: getExterior,
            getYears: getYears,
            getEffectives: getEffectives,
            postExterior: postExterior,
            getConfigSetting: getConfigSetting,
            getCourseItems: getCourseItems,
            getSelectActive: getSelectActive,
            getExternaltype: getExternaltype,
            getCurrency: getCurrency,
            getUnfinishedActivities: getUnfinishedActivities,
            getCertificateType: getCertificateType,
            getLicensesNames: getLicensesNames,
            postFinancial: postFinancial,
            getAuthorizedHours: getAuthorizedHours,
            postLearningRecord: postLearningRecord,
            postExamSurveyContent: postExamSurveyContent,
            getExamSurveyContent: getExamSurveyContent,
            getCourseDetail: getCourseDetail,
            getAuthorizedHoursCourse: getAuthorizedHoursCourse,
            postSessionAction: postSessionAction,
            getCourseListAll: getCourseListAll,
            getCourseList: getCourseList,
            getMenu: getMenu,
            getCollectionList: getCollectionList,
            addCollection: addCollection,
            delCollection: delCollection,
            hasEnrollQuestion: hasEnrollQuestion,
            loadLangs: loadLangs,
            getCarousel: getCarousel,
            checkCourseWithMenu: checkCourseWithMenu,
            checkItem: checkItem,
        };
        return service;

        function getConfigSetting() {
            let newApiURL = apiUrl.tsApi + 'checkConfig';
            newApiURL = commonService.URLCheck(newApiURL)

            //2023-07-18 Johnson 資安2023
            return eval(function (p, a, c, k, e, r) { e = String; if (!''.replace(/^/, String)) { while (c--) r[c] = k[c] || c; k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('$0.1(2);', 3, 3, 'http|get|newApiURL'.split('|'), 0, {}))
        }

        function getCourseLog(lang) {
            var params = {
                LanguageCode: lang,
                UserId: $rootScope.userInfo.userAccount,
                StartIndex: 1,
                EndIndex: 99999,
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call MyFinishedActivities,params:", params);
            return ctmsService.MyFinishedActivities(params).then(function(data) {
                if (!data) { return null; }
                _.forEach(data, function(item) {
                    item.LanguageCode = params.LanguageCode;
                });
                return data;
            });
        }

        // 取得待修項目資料
        function getUnfinishedActivities(lang) {
            var params = {
                LanguageCode: lang,
                UserId: $rootScope.userInfo.userAccount,
                tkn: sessionStorage.getItem('token')
            };
            //console.log("call MyUnfinishedActivities,params:", params);
            return ctmsService.MyUnfinishedActivities(params).then(function(data) {
                if (!data) { return null; }
                _.forEach(data, function(item) { item.LanguageCode = params.LanguageCode; });
                //console.log("MyUnfinishedActivities,data:", data);
                return data;
            });
        }


        // 取得課程詳細資訊
        function getCourseDetail(item) {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                CourseType: item.courseType,
                SessionId: item.sessionId,
                IsProgram: item.courseType === enumCourseType.courage ? 1 : 0,
                tkn: sessionStorage.getItem('token')
            };
            //console.log("call CourseSession,params:", params);
            return ctmsService.CourseSession(params).then(function(data) {
                if (!data) { return null; }
                data.LanguageCode = params.LanguageCode;
                if (data.courses) {
                    _.forEach(data.courses, function(item) {
                        item.LanguageCode = params.LanguageCode;
                    });
                }
                return data;
            });
        }

        //取得課程行為清單
        function getSelectActive(item) {
            //console.log('active item:',item);
            var params = {
                LanguageCode: item.LanguageCode,
                UserId: $rootScope.userInfo.userAccount,
                SessionId: item.sessionId,
                IsProgram: item.courseType === enumCourseType.courage ? 1 : 0,
                tkn: sessionStorage.getItem('token')
            };
            if (isTestMode) {
                //為了要實踐簡單互動
                params.courseType = item.courseType;
            }
            // console.log("call EnrollmentAvailableAction,params:", params);
            return ctmsService.EnrollmentAvailableAction(params).then(function(data) {
                // console.log("EnrollmentAvailableAction result:", data);
                if (!data) { return null; }
                data.LanguageCode = params.LanguageCode;
                _.forEach(data.lmsItems, function(item) {
                    item.LanguageCode = params.LanguageCode;
                });
                console.log('WS14 : EnrollmentAvailableAction result: ',data);
                return data;
            });
        }

        // 取得金融證照記錄
        function getFinancial(status) {
            var params = {
                UserId: $rootScope.userInfo.userAccount,
                LanguageCode: sessionStorage.getItem('userLang'),
                Status: status,
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call FCCertificatedLicenseList,params:", params);
            // console.log("result :",ctmsService.FCCertificatedLicenseList(params));
            return ctmsService.FCCertificatedLicenseList(params);
        }


        // 取得證書認列時數
        function getAuthorizedHours() {
            var params = {
                UserId: $rootScope.userInfo.userAccount,
                LanguageCode: sessionStorage.getItem('userLang'),
                LicenseId: '-1',
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call FCAuthorizedHoursList,params:", params);
            return ctmsService.FCAuthorizedHoursList(params);
        }

        function getCourseItems(activityItem) {
            //取得課程教材
            var params = {
                ItemId: activityItem.itemId,
                UserId: $rootScope.userInfo.userAccount,
                LanguageCode: activityItem.LanguageCode,
                tkn: sessionStorage.getItem('token'),
            };
            console.log("call CourseItem,params:", params);
            return ctmsService.CourseItem(params).then(function(data) {
                if (!data) { return null; }
                data.LanguageCode = params.LanguageCode;
                data.AttachmentSerilNo = params.ItemId;
                console.log("getCourseItems :", data);
                return data;
            });
        }

        function getBankBook(year, lang) {
            var params = {
                UserId: $rootScope.userInfo.userAccount,
                Annual: year,
                LanguageCode: lang,
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call MyTrainingPoint,params:", params);
            return ctmsService.MyTrainingPoint(params).then(function(data) {
                if (!data) { return null; }
                var returnResult = {
                    bankBook: data.trainingPoints,
                    remainPoint: data.remainPoint,
                    LanguageCode: params.LanguageCode,
                };
                if (new Date().getFullYear() + '' !== year + '') {
                    // 選擇的年份如果不是當前年份，則剩餘點數為0
                    returnResult.remainPoint = '0';
                }
                return returnResult;
            });
        }

        // 取得主辦單位
        function getExterior() {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                Type: 5, // 主辦單位
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call SysTypesList,params:", params);
            return ctmsService.SysTypesList(params);
        }

        // 取得證照有效狀態
        function getEffectives() {
            /*--(2016-09-29)
            如今日電話說明因 有效證照 為固定值
            由旭聯提供定義值即可 (無須透過API取得)
            已更新規格請見附件，謝謝！
            若有問題再麻煩與我聯繫喔，謝謝~
            Raina
            */
            var stateList = [{
                id: -1,  // 數值無法為空，所以使用 -1
                name: $rootScope.translate.tsunFinacialCertificationStatusAll
            }, {
                id: 0,
                name: $rootScope.translate.tsunFinacialCertificationStatusInactive
            }, {
                id: 1,
                name: $rootScope.translate.tsunFinacialCertificationStatusActive
            }, {
                id: 2,
                name: $rootScope.translate.tsunFinacialCertificationStatusCancel
            }, {
                id: 3,
                name: $rootScope.translate.tsunFinacialCertificationStatusRemove
            }];
            return $q.when(stateList);
        }

        // 取得證照類別
        function getCertificateType() {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                Type: 2, // 證照類別
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call SysTypesList,params:", params);
            return ctmsService.SysTypesList(params);
        }

        // 依證照類別取得所有證照名稱
        function getLicensesNames(licenseCategoryId) {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                LicenseCategoryId: licenseCategoryId,
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call FCLicenseList,params:", params);
            return ctmsService.FCLicenseList(params);
        }

        // 取得外訓種類
        function getExternaltype() {
            // var params = {
            //     LanguageCode: sessionStorage.getItem('userLang'),
            //     Type: 4, // 外訓種類
            //     tkn: sessionStorage.getItem('token')
            // };
            // // console.log("call SysTypesList,params:", params);
            // return ctmsService.SysTypesList(params);
            var result = [{
                    //請選擇
                    id: -1,
                    name: $rootScope.translate.commonPleaseSelect,
                    allowanceRate: 0,
                    sortIndex: 0,
                }, {
                    //一般外訓
                    id: 1,
                    name: $rootScope.translate.tsunExternalType1,
                    allowanceRate: 0,
                    sortIndex: 1,
                },
                {
                    //外語進修補助
                    id: 2,
                    name: $rootScope.translate.tsunExternalType2,
                    allowanceRate: 50,
                    sortIndex: 2,
                },
                {
                    //電腦進修補助
                    id: 3,
                    name: $rootScope.translate.tsunExternalType3,
                    allowanceRate: 50,
                    sortIndex: 3,
                },
                {
                    //考試補助
                    id: 4,
                    name: $rootScope.translate.tsunExternalType4,
                    allowanceRate: 100,
                    sortIndex: 4,
                },
                {
                    //國外外訓
                    id: 0,
                    name: $rootScope.translate.tsunExternalType0,
                    allowanceRate: 0,
                    sortIndex: 5,
                },
            ];
            return result;
        }

        // 取得繳費幣別
        function getCurrency() {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                Type: 3, // 幣別
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call SysTypesList,params:", params);
            return ctmsService.SysTypesList(params);
        }

        // 取得問卷或測驗題目
        function getExamSurveyContent(sessionId, activityItem) {
            var params = {
                LanguageCode: activityItem.LanguageCode,
                SessionId: sessionId,
                ItemId: activityItem.itemId,
                UserId: $rootScope.userInfo.userAccount,
                tkn: sessionStorage.getItem('token')
            };
            if (isTestMode) {
                //為了要實踐簡單互動
                params.type = activityItem.type;
            }
            // console.log("call ExamSurveyContent,params:", params);
            return ctmsService.ExamSurveyContent(params).then(function(result) {
                // console.log("get ExamSurveyContent");
                result.LanguageCode = params.LanguageCode;
                return result;
            });
        }
        //回傳問卷或測驗填答
        function postExamSurveyContent(sessionId, examContent) {
            var params = {
                LanguageCode: examContent.LanguageCode,
                UserId: $rootScope.userInfo.userAccount,
                SessionId: sessionId,
                ExamHistoryId: examContent.examHistoryId,
                UserResponse: examContent.answers,
                ItemId: examContent.itemId,
                Finish: examContent.finish,
                tkn: sessionStorage.getItem('token')
            };
            if (isTestMode) {
                //為了要實踐簡單互動
                // console.log("postExamSurveyContent:", params);
                params.type = examContent.activeItemtype;
            }
            // console.log("call InteractionData,params:", params);
            return ctmsService.InteractionData(params).then(function(result) {
                // console.log("send InteractionData");
                return result;
            });
        }



        // 外訓申請 (POST
        function postExterior(item) {
            //console.log('postExterior item:',item);
            // var dateTimeString = getCourseDatesString(item);
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                UserId: $rootScope.userInfo.userAccount,
                CourseName: item.Name,
                OrganizationId: '',
                Type: item.type.id,
                Outline: item.Outline,
                CourseDate: '',
                CourseTime: '',
                Location: item.Place,
                Course_Cost_Currency_1: item.currency,
                Course_Cost_Amount_1: item.coursePrice,
                Transportation_Cost_Amount_1: item.travelPrice,
                Course_Converting_Amount_1: item.totalPrice,
                CourseRemark: item.Remark || '　',
                tkn: sessionStorage.getItem('token')
            };
            // 把上課日期串成字串
            // ex "2016/01/02,2016/01/04"
            _.forEach(item.dateSettingList, function(perDateStr) {
                _.forEach(perDateStr.innerDataDate, function(dateValue) {
                    if (params.CourseDate.length > 0) { params.CourseDate += ','; }
                    params.CourseDate += dateValue;
                });
                _.forEach(perDateStr.innerDataTime, function(timeValue) {
                    if (params.CourseTime.length > 0) { params.CourseTime += ','; }
                    params.CourseTime += timeValue;
                });
            });

            // 把主辦單位的 id 串起來 
            // ex "3,4,7,8"
            _.forEach(item.organizer, function(perOrg) {
                params.OrganizationId += perOrg.id + ',';
            });
            if (params.OrganizationId.length > 0) { // 去掉最後一個逗號
                params.OrganizationId = params.OrganizationId.substring(0, params.OrganizationId.length - 1);
            }
            //console.log("call ExternalTrainingApplication,params:", params);
            return ctmsService.ExternalTrainingApplication(params).then(function(result) {
                if (!result) { return null; }
                toastr.success($rootScope.translate.tsunSuccessExternalApplication);
                return result;
            });
        }

        // 證照申請 (POST
        function postFinancial(item) {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                UserId: $rootScope.userInfo.userAccount,
                LicenseId: item.licenses.id,
                AcquireDate: item.getDay,
                LicenseCode: item.licensesNO || '　',
                Comment: item.otherMark || '　',
                tkn: sessionStorage.getItem('token')
            };
            console.log("call FCCertificatedLicenseAdd,params:", params);
            return ctmsService.FCCertificatedLicenseAdd(params);
        }

        // 學習記錄回傳 (POST
        function postLearningRecord(item, isAlert) {
            //console.log('WS 21 Learning Record item :', item);
            if (!item) { return; }
            var params = {
                ItemId: item.ItemId,
                SessionId: item.SessionId,
                Duration: item.Duration,
                UserId: $rootScope.userInfo.userAccount,
                LanguageCode: item.LanguageCode,
                tkn: sessionStorage.getItem('token'),
            };
            //console.log('item is not null');
            //測試關閉瀏覽器有無傳送資料
            // var str = 'return OK';
            // headerService.saveLearnLog(str);
            
            commonService.setCtmsParams(params);
            //console.log("call LearningRecordCommit,params:", params);
            return ctmsService.LearningRecordCommit(params).then(function(data) {
                // console.log("send LearningRecordCommit");
                if (!data) { return null; }
                if (isAlert) {
                    toastr.success($rootScope.translate.tsunSendSuccess);
                }
                return true;
            }).catch((reason)=>{
                // chris: log for mobile
                //console.log('ctms-learning-record-error:',reason);
                postException(`ctms-learning-record-error: ${JSON.stringify(reason)}`, apiUrl)
                throw reason;
            });
        }



        function getYears(minYear) {
            var thisYear = new Date().getFullYear();
            minYear = minYear || thisYear - 10;
            // console.log("getYears , minYear:", minYear);
            var years = [];
            for (var i = thisYear; i > thisYear - 10; i--) {
                if (i >= minYear) {
                    years.push(i);
                }
            }
            return years;
        }

        function getAuthorizedHoursCourse(item, lang) {
            var params = {
                LanguageCode: lang,
                UserId: $rootScope.userInfo.userAccount,
                LicenseId: item.licenseId,
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call FCEnrollableActivities,params:", params);
            return ctmsService.FCEnrollableActivities(params).then(function(data) {
                if (!data) { return null; }
                _.forEach(data, function(item) {
                    item.LanguageCode = params.LanguageCode;
                });
                return data;
            });
        }

        function postSessionAction(sessionItem, Action) {
            var params = {
                tkn: sessionStorage.getItem('token'),
                LanguageCode: sessionItem.LanguageCode,
                UserId: $rootScope.userInfo.userAccount,
                SessionId: sessionItem.sessionId,
                IsProgram: sessionItem.courseType === enumCourseType.courage ? 1 : 0,
                ActionType: Action,
            };
            // console.log("call EnrollmentAction,params:", params);
            return ctmsService.EnrollmentAction(params).then(function(result) {
                if (!result) { return null; }
                toastr.success($rootScope.translate.tsunSendSuccess);
                return result;
            });
        }



        function getMenu(langCode) {
            langCode = langCode || sessionStorage.getItem('langCode');
            //console.log("send tsapi.CourseList   langCode:", langCode);
            let newApiURL = apiUrl.tsApi + 'ctms/CourseCategory?langSerilNo=' + langCode;
            newApiURL = commonService.URLCheck(newApiURL)
            
            //2023-07-18 Johnson 資安2023
            return eval(function (p, a, c, k, e, r) { e = String; if (!''.replace(/^/, String)) { while (c--) r[c] = k[c] || c; k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('$0.1(2);', 3, 3, 'http|get|newApiURL'.split('|'), 0, {}))

            //2023-07-17 Johnson 資安2023
            //var csrfToken = sessionStorage.getItem('token');
            //return $http.get(newApiURL, csrfToken).then(function (result) {
            //    return result.data;
            //});
        }

        // 取得課程列表
        function getCourseList(classificationId, langCode) {
            //console.log("classificationId:", classificationId);
            var params = {
                UserId: $rootScope.userInfo.userAccount,
                LanguageCode: langCode,
                ClassificationId: parseInt(classificationId)||-1,
                CourseType: -1,
                tkn: sessionStorage.getItem('token'),
            };
            //三個= 不會有作用，請保留2個就好
            if(classificationId==0){
                params.ClassificationId=0;
            }
            //console.log(" params.ClassificationId:",  params.ClassificationId);

            //console.log("call PublishedActivity,params:", params);
            return ctmsService.PublishedActivity(params).then(function(data) {
                _.forEach(data, function(item) {
                    item.LanguageCode = params.LanguageCode;
                });
                return data;
            });
        }

        function getCourseListAll(catagoryId) {
            //取得不分語系的課程清單
            return loadLangs()
                .then(function(langs) {
                    //console.log('langs:',langs);
                    var coursePromist = [];
                    _.forEach(langs, function(lang) {
                        // console.log('lang:', lang.langCode)
                        // console.log( getCourseList(catagoryId, lang.langCode))
                        coursePromist.push(getCourseList(catagoryId, lang.langCode));
                    });
                    return $q.all(coursePromist).then(function(data) {
                        var resultCourseList = []; //全部課程清單
                        if (data) {
                            _.forEach(data, function(courseList) {
                                //console.log('courseList:', courseList)
                                courseList = _.orderBy(courseList, [ 'courseTime'], ['desc'] );
                                Array.prototype.push.apply(resultCourseList, courseList);
                            });
                            resultCourseList = _.uniqBy(resultCourseList, function(courseItem) {
                                return courseItem.sessionId;
                            });
                        }
                        return resultCourseList;
                    });
                })
                .then(function(resultCourseList) {
                    //final
                    //console.log('resultCourseList:', resultCourseList);
                    return resultCourseList;
                });
        }

        function checkCourseWithMenu(courseList/*, catagoryList*/) {
            var resultCourseList = courseList;

            //filter將排序打亂了，先將filter拿掉
            // console.log("courseList:", courseList);
            // console.log("catagoryList:", catagoryList);

            // _.forEach(catagoryList, function(catagoryItem) {

            //     var courseIsValid = _.filter(courseList, function(courseItem) {
            //         var checkResult;
            //         //console.log("catagoryItem:", catagoryItem);
            //         //console.log("courseItem:", courseItem);
            //         checkResult = parseInt(courseItem.classificationId) === parseInt(catagoryItem.categoryId);
            //         return checkResult;
            //     });

            //     //console.log("courseIsValid:", courseIsValid);
            //     Array.prototype.push.apply(resultCourseList, courseIsValid);
            // });
                
            //console.log("resultCourseList:", resultCourseList);
            resultCourseList = _.uniqBy(resultCourseList, function(courseItem) {
                return courseItem.sessionId;
            });
            return $q.when(resultCourseList);
        }

        function getCollectionList(langCode) {
            var params = {
                sysCode: sysCode,
                tkn: sessionStorage.getItem('token'),
                sysLang: langCode || null,
            };

			return $http.post(apiUrl.tsApi + 'Collection/GetList', params, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			})
			.then(function(data) {
				if (!data) { return null; }
				return data.data.collectionList;
			});
        }

        function addCollection(sessionItem) {
            var params = {
                sysCode: sysCode,
                tkn: sessionStorage.getItem('token'),
                collectionSessionId: sessionItem.sessionId,
                langSerilNo: sessionStorage.getItem('langCode'),
                sysLang: sessionStorage.getItem('langCode'),
            };
            return $http.post(apiUrl.tsApi + 'Collection/Save', params, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			})
			.then(function(result) {
                toastr.success(result.data);
            });
        }

        function delCollection(sessionItem, isAlert) {
            var params = {
                sysCode: sysCode,
                tkn: sessionStorage.getItem('token'),
                collectionSessionId: sessionItem.sessionId,
                sysLang: sessionStorage.getItem('langCode'),
            };
			
			return $http.post(apiUrl.tsApi + 'Collection/Del', params, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			})
			.then(function(result) {
				if (isAlert) { toastr.success(result.data); }
			});
            
        }

        function hasEnrollQuestion(item) {
            return getSelectActive(item).then(function(data) {
                if (!data) { return null; }
                return data.preSurveyItemId > 0;
            });
        }

        function loadLangs() {
            return translateService.getLanguage().then(function(data) {
                if (!data) { return null; }
                return _.orderBy(data.data, ['selected', 'langSerilNo'], ['desc', 'asc']);
            });
        }

        function getCarousel(activeType) {
            var param = {};
            var postUrl = '';
            commonService.setParams(param);
            switch (activeType) {
                case 3:
                    postUrl = apiUrl.tsApi + 'ActiveHotRecommend/PostSmallCourse';
                    break;
                default:
                    postUrl = apiUrl.tsApi + 'ActiveHotRecommend/postHotRecommend';
                    break;
            }
            return $http.post(postUrl, param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			})
			.then(function(data) {
                if (!data) { return null; }
                return data.data;
            });
        }

        function checkItem(item) {
            var params = {
                attachmentSerilNo: item.AttachmentSerilNo,
                fileUrl: item.fileUrl,
                tkn: sessionStorage.getItem('token'),
            };

            return $http.post(apiUrl.tsApi + 'ctms/ItemCheck', params, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
        }
    }
})();